import { CSSProperties, useEffect, useState } from 'react';
import { checkImage } from '../util/checkImage';
import produce from 'immer';

interface Resources {
  style: CSSProperties;
  images: string[];
}

export interface GalleryCategories {
  [key: string]: Resources;
}

function useDynamicImageLoading(
  selectedCategorySettings: SelectedCategorySettings<GalleryCategories>,
  galleriesBasePath: any
) {
  const [settings, setSettings] = useState(selectedCategorySettings);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!loading) {
      return;
    }

    const getImageName = (index: number) => `IMG_${index}.png`;
    const recursiveCheck = async (index: number, galleryKey: string): Promise<any> => {
      const stateCheckImage = (await checkImage(
        galleriesBasePath[galleryKey] + getImageName(index)
      )) as {
        path: string;
        status: 'ok' | 'error';
      };
      if (stateCheckImage.status === 'ok') {
        setSettings(
          produce((draft) => {
            draft.gallery[galleryKey].images.push(stateCheckImage.path);
          })
        );
        return recursiveCheck(index + 1, galleryKey);
      } else {
        return Promise.resolve();
      }
    };

    (async () => {
      for (const galleryKey of Object.keys(galleriesBasePath)) {
        await recursiveCheck(0, galleryKey);
      }
      setLoading(false);
    })();
  }, [loading]);

  return [loading, settings];
}

export default useDynamicImageLoading;
